<template>
  <div>
    <div
      v-if="layout === 'filters'"
      :class="['paginator', 'paginator--' + layout, 'paginator--' + position]"
    >
      <div class="paginator__controls">
        <LayoutButtonGroup>
          <FormButton
            class="paginator__hidden--md"
            :text="type !== 'news' ? 'Prev' : 'First'"
            icon='<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M23.677 18.52c.914 1.523-.183 3.472-1.967 3.472h-19.414c-1.784 0-2.881-1.949-1.967-3.472l9.709-16.18c.891-1.483 3.041-1.48 3.93 0l9.709 16.18z"/></svg>'
            iconSize="xxs"
            iconRotate="270deg"
            :disabled="loading || currentPage === 1 ? true : false"
            @clicked="changePage('prev')"
          />

          <FormButton
            icon='<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M19 12l-18 12v-24l18 12zm4-11h-4v22h4v-22z"/></svg>'
            iconSize="xxs"
            iconRotate="180deg"
            :disabled="loading || currentPage === 1 ? true : false"
            @clicked="changePage('first')"
          />
        </LayoutButtonGroup>

        <div class="paginator__info">
          <p v-if="total === 0">No results</p>
          <p v-else-if="total > 0 && !loading">Results <span>{{ from }}</span> - <span>{{ to }}</span> from <span>{{ total }}</span></p>
          <p v-else>Loading...</p>
        </div>

        <LayoutButtonGroup>
          <FormButton
            v-if="lastPage <= 416"
            icon='<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M19 12l-18 12v-24l18 12zm4-11h-4v22h4v-22z"/></svg>'
            iconSize="xxs"
            :flipLayout="true"
            :disabled="loading || currentPage >= lastPage ? true : false"
            @clicked="changePage('last')"
          />

          <FormButton
            class="paginator__hidden--md"
            text="Next"
            icon='<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M23.677 18.52c.914 1.523-.183 3.472-1.967 3.472h-19.414c-1.784 0-2.881-1.949-1.967-3.472l9.709-16.18c.891-1.483 3.041-1.48 3.93 0l9.709 16.18z"/></svg>'
            iconSize="xxs"
            iconRotate="90deg"
            :flipLayout="true"
            :disabled="loading || currentPage >= lastPage ? true : false"
            @clicked="changePage('next')"
          />
        </LayoutButtonGroup>
      </div>
    </div>

    <div
      v-if="layout === 'full' || layout === 'table'"
      :class="['paginator', 'paginator--' + layout, 'paginator--' + position]"
    >
      <div class="paginator__controls">
        <LayoutButtonGroup>
          <FormButton
            :text="type !== 'news' ? 'Prev' : 'First'"
            :variant="layout === 'table' ? 'black' : 'dark'"
            icon='<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M23.677 18.52c.914 1.523-.183 3.472-1.967 3.472h-19.414c-1.784 0-2.881-1.949-1.967-3.472l9.709-16.18c.891-1.483 3.041-1.48 3.93 0l9.709 16.18z"/></svg>'
            iconSize="xxs"
            iconRotate="270deg"
            :disabled="loading || currentPage === 1 ? true : false"
            @clicked="changePage('prev')"
          />

          <FormButton
            v-if="type !== 'news'"
            :variant="layout === 'table' ? 'black' : 'dark'"
            icon='<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M19 12l-18 12v-24l18 12zm4-11h-4v22h4v-22z"/></svg>'
            iconSize="xxs"
            iconRotate="180deg"
            :disabled="loading || currentPage === 1 ? true : false"
            @clicked="changePage('first')"
          />
        </LayoutButtonGroup>

        <LayoutButtonGroup v-if="showPages">
          <FormButton
            v-for="page in pages(windowWidth < 760 ? 'md' : 'lg')"
            :variant="layout === 'table' ? 'black' : 'dark'"
            :text="page"
            :iconReversed="false"
            :scaleText="true"
            :noPadding="true"
            :selected="page === currentPage ? true : false"
            :disabled="loading"
            @clicked="changePage(page)"
          />
        </LayoutButtonGroup>

        <LayoutButtonGroup>
          <FormButton
            v-if="lastPage <= 416"
            :variant="layout === 'table' ? 'black' : 'dark'"
            icon='<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M19 12l-18 12v-24l18 12zm4-11h-4v22h4v-22z"/></svg>'
            iconSize="xxs"
            :flipLayout="true"
            :disabled="loading || currentPage >= lastPage ? true : false"
            @clicked="changePage('last')"
          />

          <FormButton
            :variant="layout === 'table' ? 'black' : 'dark'"
            text="Next"
            icon='<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M23.677 18.52c.914 1.523-.183 3.472-1.967 3.472h-19.414c-1.784 0-2.881-1.949-1.967-3.472l9.709-16.18c.891-1.483 3.041-1.48 3.93 0l9.709 16.18z"/></svg>'
            iconSize="xxs"
            iconRotate="90deg"
            :flipLayout="true"
            :disabled="loading || currentPage >= lastPage ? true : false"
            @clicked="changePage('next')"
          />
        </LayoutButtonGroup>
      </div>
    </div>

    <div
      v-if="layout === 'condensed'"
      :class="['paginator', 'paginator--' + layout, 'paginator--' + position]"
    >
      <div class="paginator__info">
        <p class="paginator__info--xs">Results <span>{{ from }}</span>-<span>{{ to }}</span> / <span>{{ total }}</span></p>
        <p class="paginator__info--sm">Results <span>{{ from }}</span> to <span>{{ to }}</span> from <span>{{ total }}</span></p>
        <p class="paginator__info--md">Results <span>{{ from }}</span> to <span>{{ to }}</span> from <span>{{ total }}</span> matches</p>
      </div>

      <div class="paginator__controls">
        <LayoutButtonGroup>
          <FormButton
            icon='<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M19 12l-18 12v-24l18 12zm4-11h-4v22h4v-22z"/></svg>'
            iconSize="xxs"
            iconRotate="180deg"
            :disabled="loading || currentPage === 1 ? true : false"
            @clicked="changePage('first')"
          />

          <FormButton
            class="paginator__hidden--md"
            icon='<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M23.677 18.52c.914 1.523-.183 3.472-1.967 3.472h-19.414c-1.784 0-2.881-1.949-1.967-3.472l9.709-16.18c.891-1.483 3.041-1.48 3.93 0l9.709 16.18z"/></svg>'
            iconSize="xxs"
            iconRotate="270deg"
            :disabled="loading || currentPage === 1 ? true : false"
            @clicked="changePage('prev')"
          />

          <FormButton
            v-if="showPages"
            v-for="page in pages('sm')"
            :text="page"
            :iconReversed=true
            :selected="page === currentPage ? true : false"
            :disabled="loading"
            @clicked="changePage(page)"
          />

          <FormButton
            class="paginator__hidden--md"
            icon='<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M23.677 18.52c.914 1.523-.183 3.472-1.967 3.472h-19.414c-1.784 0-2.881-1.949-1.967-3.472l9.709-16.18c.891-1.483 3.041-1.48 3.93 0l9.709 16.18z"/></svg>'
            iconSize="xxs"
            iconRotate="90deg"
            :disabled="loading || currentPage >= lastPage ? true : false"
            @clicked="changePage('next')"
          />

          <FormButton
            v-if="lastPage <= 416"
            icon='<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M19 12l-18 12v-24l18 12zm4-11h-4v22h4v-22z"/></svg>'
            iconSize="xxs"
            :disabled="loading || currentPage >= lastPage ? true : false"
            @clicked="changePage('last')"
          />
        </LayoutButtonGroup>
      </div>
    </div>

    <div
      v-if="layout === 'text'"
      :class="['paginator', 'paginator--' + layout, 'paginator--' + position]"
    >
      <div class="paginator__controls">
        <LayoutButtonGroup :borderless="true">
          <FormButton
            class="paginator__hidden--md"
            variant="light"
            :borderless="true"
            text="Prev"
            icon='<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M23.677 18.52c.914 1.523-.183 3.472-1.967 3.472h-19.414c-1.784 0-2.881-1.949-1.967-3.472l9.709-16.18c.891-1.483 3.041-1.48 3.93 0l9.709 16.18z"/></svg>'
            iconSize="xxs"
            iconRotate="270deg"
            :disabled="loading || currentPage === 1 ? true : false"
            @clicked="changePage('prev')"
          />

          <FormButton
            variant="light"
            :borderless="true"
            icon='<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M19 12l-18 12v-24l18 12zm4-11h-4v22h4v-22z"/></svg>'
            iconSize="xxs"
            iconRotate="180deg"
            :disabled="loading || currentPage === 1 ? true : false"
            @clicked="changePage('first')"
          />
        </LayoutButtonGroup>

        <LayoutButtonGroup :borderless="true">
          <FormButton
            v-for="page in pages('lg')"
            variant="light"
            :borderless="true"
            :text="page"
            :iconReversed=true
            :selected="page === currentPage ? true : false"
            :disabled="loading"
            @clicked="changePage(page)"
          />
        </LayoutButtonGroup>

        <LayoutButtonGroup :borderless="true">
          <FormButton
            variant="light"
            :borderless="true"
            icon='<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M19 12l-18 12v-24l18 12zm4-11h-4v22h4v-22z"/></svg>'
            iconSize="xxs"
            :flipLayout="true"
            :disabled="loading || currentPage >= lastPage ? true : false"
            @clicked="changePage('last')"
          />

          <FormButton
            class="paginator__hidden--md"
            variant="light"
            :borderless="true"
            text="Next"
            icon='<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M23.677 18.52c.914 1.523-.183 3.472-1.967 3.472h-19.414c-1.784 0-2.881-1.949-1.967-3.472l9.709-16.18c.891-1.483 3.041-1.48 3.93 0l9.709 16.18z"/></svg>'
            iconSize="xxs"
            iconRotate="90deg"
            :flipLayout="true"
            :disabled="loading || currentPage >= lastPage ? true : false"
            @clicked="changePage('next')"
          />
        </LayoutButtonGroup>
      </div>
    </div>
  </div>
</template>

<script>
import FormButton from '@/components/form/Button.vue'
import LayoutButtonGroup from '@/components/layout/ButtonGroup.vue'

export default {
  components: {
    FormButton,
    LayoutButtonGroup
  },
  props: {
    layout: {
      type: String,
      default: 'full',
      validator (values) {
        return ['full', 'condensed', 'text', 'filters', 'table'].includes(values)
      }
    },
    position: {
      type: String,
      default: 'top'
    },
    showPages: {
      type: Boolean,
      default: true
    },
    currentPage: {
      type: [String, Number],
      default: 1
    },
    lastPage: {
      type: [String, Number],
      default: 1
    },
    perPage: {
      type: [String, Number],
      default: 24
    },
    from: {
      type: [String, Number],
      default: 1
    },
    to: {
      type: [String, Number],
      default: 1
    },
    total: {
      type: [String, Number],
      default: 1
    },
    type: {
      type: [String],
      default: 'datasets'
    },
    loading: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      windowWidth: window.innerWidth,
      status: 'default',
      changingPage: false
    }
  },
  methods: {
    pages (size) {
      let pages = []
      let loop = size === 'lg' ? -3 : 0

      while (loop < (size === 'lg' ? 4 : 1)) {
        let injectedPage = this.currentPage + loop <= this.lastPage ? this.currentPage + loop : this.lastPage - (loop + (size === 'lg' ? 3 : 0))

        if (injectedPage < 1) {
          injectedPage = injectedPage + (size === 'lg' ? 7 : 1)
        }
        if (injectedPage > this.lastPage) {
          injectedPage = false
        }
        if (injectedPage !== false) {
          pages.push(injectedPage)
        }

        loop++
      }

      return pages.sort(function(a, b){return a-b})
    },
    changePage (value) {
      let newPage = false

      if (value === 'first') {
        newPage = 1
      } else if (value === 'prev') {
        let checkPage = this.currentPage - 1

        if (checkPage >= 1) {
          newPage = checkPage
        }

        if (this.type === 'news') {
          newPage = 1
        }
      } else if (value === 'next') {
        let checkPage = this.currentPage + 1

        if (checkPage <= this.lastPage) {
          newPage = checkPage
        }
      } else if (value === 'last') {
        newPage = this.lastPage
      } else {
        if (value >= 1 && value <= this.lastPage) {
          newPage = value
        }
      }

      if (newPage !== false && newPage !== this.currentPage) {
        this.$emit('changed', newPage)
      }
    },
    onResize() {
      this.windowWidth = window.innerWidth
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.nextItem)
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.paginator {
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  width: 100%;
  height: 36px;

  @media screen and (min-width: $breakpointLg) {
    height: 40px;
  }

  &--full {
    //background-color: $bg-2;

    .paginator__controls {
      flex: 1;
      justify-content: space-between;
    }
  }

  &--filters {
    .paginator__controls {
      flex: 1;
      justify-content: space-between;
    }
  }

  &--condensed {
    
  }

  &--text {
    //background-color: $bg-4;

    .paginator__controls {
      flex: 1;
      justify-content: space-between;
    }
  }

  &--table {
    .paginator__controls {
      flex: 1;
      justify-content: space-between;
    }
  }

  &--top {
    border-top: 1px solid $black;
    border-bottom: 1px solid $black;
  }

  &--bottom {
    //border-top: 1px solid rgba($white, 0.1);
    //border-bottom: 1px solid $black;
  }

  &--middle {
    border-top: 1px solid rgba($white, 0.1);
  }

  &__info {
    display: flex;
    align-items: center;
    overflow: hidden;

    &--xs {
      display: block;

      @media screen and (min-width: $breakpointSm) {
        display: none;
      }
    }

    &--sm {
      display: none;

      @media screen and (min-width: $breakpointSm) {
        display: block;
      }

      @media screen and (min-width: $breakpointMd) {
        display: none;
      }
    }

    &--md {
      display: none;

      @media screen and (min-width: $breakpointMd) {
        display: block;
      }
    }

    p {
      @include font('content--sm', $white, 0.7);
      margin: 0 16px;

      @media screen and (min-width: $breakpointLg) {
        @include font('content--md', $white, 0.7);
        margin: 0 16px;
      }

      span {
        color: $white;
      }
    }
  }

  &__controls {
    display: flex;
  }

  &__hidden {
    &--md {
      display: none;

      @media screen and (min-width: $breakpointMd) {
        display: flex;
      }
    }
  }
}

</style>
